/**
 * Configuração vinda do build. Nenhum domínio fica em código: o mesmo bundle serve
 * qualquer origem, e quem decide para onde apontar é `VITE_API_BASE_URL`.
 *
 * Sem a variável, o app assume que a API está na própria origem (proxy reverso).
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? window.location.origin;

const DEFAULT_PLATFORM_NAME = 'Cofisco';

/**
 * Host pelo qual o app acha o seu escritório (`GET /api/tenant/?host=`). O `||` trata a variável
 * vazia como ausente: um `VITE_TENANT_HOST=` copiado do `.env.example` não pode esconder o host real.
 */
export const TENANT_HOST: string = (import.meta.env.VITE_TENANT_HOST || window.location.hostname)
  .trim()
  .toLowerCase();

/** Nome da plataforma, usado só nas telas neutras (antes de existir um escritório). */
export const PLATFORM_NAME: string = import.meta.env.VITE_PLATFORM_NAME || DEFAULT_PLATFORM_NAME;

/**
 * Origem das páginas Django que o app abre fora do SPA. O host `api.` só serve a API (MT-701), então
 * o build do Worker aponta para `portal.`. O `||` trata a variável vazia como ausente: sem ela vale a
 * origem da API, que no host legado e no dev também serve as páginas.
 */
export const PORTAL_BASE_URL: string = import.meta.env.VITE_PORTAL_BASE_URL || API_BASE_URL;

/** Páginas servidas pelo backend (Django) que o app abre fora do SPA. */
export const BACKEND_ROUTES = {
  forgotPassword: '/auth/forgot-password/',
} as const;

export function backendUrl(route: (typeof BACKEND_ROUTES)[keyof typeof BACKEND_ROUTES]): string {
  return `${PORTAL_BASE_URL}${route}`;
}
